import apiClient from '../lib/apiClient';

const isMissingEndpoint = (error) => {
  const msg = String(error || '').toLowerCase();
  return msg.includes('not found') || msg.includes('404') || msg.includes('controller not found');
};

const getWithFallback = async (paths) => {
  let last = { success: false, error: 'No endpoints configured' };
  for (const path of paths) {
    try {
      const result = await apiClient.get(path);
      if (result.success) return result;
      last = result;
      if (!isMissingEndpoint(result.error)) return result;
    } catch (error) {
      last = { success: false, error: error.message || 'Request failed' };
      if (!isMissingEndpoint(last.error)) return last;
    }
  }
  return last;
};

const putWithFallback = async (paths, data) => {
  let last = { success: false, error: 'No endpoints configured' };
  for (const path of paths) {
    try {
      const result = await apiClient.put(path, data);
      if (result.success) return result;
      last = result;
      if (!isMissingEndpoint(result.error)) return result;
    } catch (error) {
      last = { success: false, error: error.message || 'Request failed' };
      if (!isMissingEndpoint(last.error)) return last;
    }
  }
  return last;
};

const employeeSelfService = {
  getMe: async () => getWithFallback(['/employee-self-service/me', '/employees/me']),

  getDashboard: async () =>
    getWithFallback(['/employee-self-service/dashboard', '/employees/self-dashboard']),

  updateProfile: async (data) =>
    putWithFallback(['/employee-self-service/profile', '/employees/self-profile'], data),

  getLeaveBalance: async () =>
    getWithFallback(['/employee-self-service/leave-balance', '/employees/self-leave-balance']),

  getDeployment: async () =>
    getWithFallback(['/employee-self-service/deployment', '/employees/self-deployment']),

  getDocuments: async () =>
    getWithFallback(['/employee-self-service/documents', '/employees/self-documents']),

  getLetters: async () =>
    getWithFallback(['/employee-self-service/letters', '/employees/self-letters']),

  getHolidays: async (year) => {
    const params = year ? { year } : {};
    let last = { success: false, error: 'No endpoints configured' };
    for (const path of ['/employee-self-service/holidays', '/employees/self-holidays']) {
      try {
        const result = await apiClient.get(path, params);
        if (result.success) return result;
        last = result;
        if (!isMissingEndpoint(result.error)) return result;
      } catch (error) {
        last = { success: false, error: error.message || 'Request failed' };
        if (!isMissingEndpoint(last.error)) return last;
      }
    }
    return last;
  },
};

export default employeeSelfService;
